/**
 * 签署 合同签署
 * 2018.8.4
 */
import { _geolocation, handleResponse, handleError, dealElement } from '../lib/common';
import ApiPort from '../config/api-port';
import HttpAxios from './http-axios';
import GlobalConfig from '../config/global';

let junziqianApi = GlobalConfig.domain.junziqianApi;

export default {
  /**
   * 获取合同签署操作的token和签名信息
   * @param signNo 合同编号
   * @returns {Promise<T>}
   */
  postSignUrl (signNo) {
    let url = junziqianApi + ApiPort.signInfoController.signUrl;

    let positon = _geolocation();
    let jsonData = { signNo: signNo, longitude: positon.longitude, latitude: positon.latitude };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * nextSignSearch 获取顺序连续信息，返回下一条签署信息，当前签署完成，就直接跳转到该搜索的信息进行下一个合同签署
   * @param signNo 签署编号
   * @param sign 签名
   * @param ts 签名
   * @returns {Promise<T>}
   */
  findNextSignSearch ({ signNo, sign, ts }) {
    let url = junziqianApi + ApiPort.signInfoController.nextSignSearch;
    let jsonData = { signNo, sign, ts };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 获取签署的信息
   * @param signNo 签署流水号
   * @param sign 请求参数签名
   * @param ts 请求签名时间戳
   * @returns {Promise<T>}
   */
  postSignContractInfo ({ signNo, sign, ts, sq }) {
    let url = junziqianApi + ApiPort.signInfoController.signInfo;
    let positon = _geolocation();
    let jsonData = { signNo: signNo, sign: sign, ts: ts, longitude: positon.longitude, latitude: positon.latitude, sq };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 获取多文件签署的信息
   * @param signNo 签署流水号
   * @param sign 请求参数签名
   * @param ts 请求签名时间戳
   * @returns {Promise<T>}
   */
  postSignMultiContractInfo ({ signNo, sign, ts }) {
    let url = junziqianApi + ApiPort.signInfoController.signInfoMulti;
    let positon = _geolocation();
    let jsonData = { signNo: signNo, sign: sign, ts: ts, longitude: positon.longitude, latitude: positon.latitude };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署验证签字密码 signPwdCheck
   * @param singPwd  签字密码
   * @param randomCode  图片验证码
   * @returns {Promise<T>}
   */
  postSignPsdCheck (signPwd, randomCode) {
    let url = junziqianApi + ApiPort.signInfoController.signPwdCheck;
    let jsonData = { signPwd: signPwd, randomCode: randomCode };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 显示标准图形章,返回的是一个图片 generalSign
   * @param signNo  签署流水号
   * @param sign  请求参数签名
   * @param ts  请求签名时间戳
   * @param timeStampSwitch  章时间显示0或null显示;1不显示
   * @returns {string}
   */
  getGeneralSign ({ signNo, sign, ts, timeStampSwitch }) {
    let url = junziqianApi + ApiPort.signInfoController.generalSign;
    let json = { signNo: signNo, sign: sign, ts: ts, timeStampSwitch: timeStampSwitch };
    let query = [];

    for (let key in json) {
      query.push(`${key}=${json[key]}`);
    }
    query = query.join('&');

    return url + '?' + query;
  },

  /**
   * 合同拒签 refuse
   * @param signNo  签署流水号
   * @param sign    请求参数签名
   * @param ts      请求签名时间戳
   * @returns {Promise<T>}
   */
  postRefuseSignApply ({ signNo, sign, ts, refusedReason }) {
    let url = junziqianApi + ApiPort.signInfoController.refuse;
    let positon = _geolocation();
    let jsonData = {
      signNo: signNo,
      sign: sign,
      ts: ts,
      longitude: positon.longitude,
      latitude: positon.latitude,
      refusedReason: refusedReason,
    };

    jsonData = dealElement(jsonData);

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署合同 返回值有值,则是下一个连续签的合同信息 done
   * @param chaptePages chaptePages
   * @param sealPages   签署信息,例:[{page:1,chaptes:[{offsetX:0.1,offsetY:0.1,sealLevel:1,sealId:1},{}]},{…}…],sealLevel不能为空可以写0都行
   * @param signNo      签署流水号
   * @param sign        请求参数签名
   * @param ts          请求签名时间戳
   * @param fromDingTalk 是否来源钉钉
   * @returns {Promise<T>}
   */
  postApplySignDone ({ chaptePages, sealPages, signNo, sign, ts, fromDingTalk }) {
    let url = junziqianApi + ApiPort.signInfoController.done;
    let postion = _geolocation();
    let jsonData = {
      chaptePages: chaptePages,
      sealPages: sealPages,
      signNo: signNo,
      sign: sign,
      ts: ts,
      longitude: postion.longitude,
      latitude: postion.latitude,
      fromDingTalk
    };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 签署多文件合同 返回值有值,则是下一个连续签的合同信息 done
   * @param chaptePages chaptePages
   * @param sealPages   签署信息,例:[{page:1,chaptes:[{offsetX:0.1,offsetY:0.1,sealLevel:1,sealId:1},{}]},{…}…],sealLevel不能为空可以写0都行
   * @param signNo      签署流水号
   * @param sign        请求参数签名
   * @param ts          请求签名时间戳
   * @param fromDingTalk 是否来自钉钉
   * @returns {Promise<T>}
   */
  postApplySignMultiDone ({ chaptePages, sealPages, signNo, sign, ts, fromDingTalk }) {
    let url = junziqianApi + ApiPort.signInfoController.multiDone;
    let postion = _geolocation();
    let jsonData = {
      chaptePages: chaptePages,
      sealPages: sealPages,
      signNo: signNo,
      sign: sign,
      ts: ts,
      longitude: postion.longitude,
      latitude: postion.latitude,
    };
    if (fromDingTalk) jsonData.fromDingTalk = fromDingTalk

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 签署登录验证，验证通过会回写token，token追加 userSignLogin
   * @param signNo        签字编号
   * @param mobilePhone   手机
   * @param email         邮箱
   * @param valicode      验证码
   * @param userId        用户id
   * @returns {Promise<T>}
   */
  postUserSignLogin ({ signNo, mobilePhone, email, valicode, userId }) {
    let url = junziqianApi + ApiPort.signInfoController.userSignLogin;
    let postion = _geolocation();
    let jsonData = {
      signNo: signNo,
      mobilePhone: mobilePhone,
      email: email,
      valicode: valicode,
      userId: userId,
      longitude: postion.longitude,
      latitude: postion.latitude,
    };
    jsonData = dealElement(jsonData);

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * sendCode 发送类型不填，发送签署验证码，不能使用通用验证码发送那个发送验证码未计数，当出错2次10分钟内，要求图形验证码api发起会扣短信次数，web不会扣
   * @param targetId    发送目标:手机或邮箱
   * @param verifyType  验证类型,参考com.jzq.common.enums.VerifyType
   * @param imgCode     图形验证码,为:${imgToken}_${用户输入的验证码}
   * @param ifDecode    发送方式是否加密:0或null不加密,1加密
   * @param signNo      签署流水号
   * @param sign        请求参数签名
   * @param ts          请求签名时间戳
   * @returns {Promise<T>}
   */
  postUserSignSendCode ({ targetId, verifyType, imgCode, ifDecode, signNo, sign, ts }) {
    let url = junziqianApi + ApiPort.signInfoController.sendCode;
    let jsonData = {
      targetId: targetId,
      verifyType: verifyType,
      imgCode: imgCode,
      ifDecode: ifDecode || 0,
      signNo: signNo,
      sign: sign,
      ts: ts,
    };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 签署登录验证，验证通过会回写token，token追加 userSignLogin
   * @param signNo        签字编号
   * @param mobilePhone   手机
   * @param email         邮箱
   * @param valicode      验证码
   * @param userId        用户id
   * @returns {Promise<T>}
   */
  postApiUserSignLogin ({ bsNo, mId, iden, mobilePhone, email, valicode, userId }) {
    let url = junziqianApi + ApiPort.signInfoController.userApiSignLogin;
    let postion = _geolocation();
    let jsonData = {
      bsNo: bsNo,
      mId: mId,
      iden: iden,
      mobilePhone: mobilePhone,
      email: email,
      valicode: valicode,
      userId: userId,
      longitude: postion.longitude,
      latitude: postion.latitude,
    };
    jsonData = dealElement(jsonData);

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * sendCode 发送类型不填，发送签署验证码，不能使用通用验证码发送那个发送验证码未计数，当出错2次10分钟内，要求图形验证码api发起会扣短信次数，web不会扣
   * @param targetId    发送目标:手机或邮箱
   * @param verifyType  验证类型,参考com.jzq.common.enums.VerifyType
   * @param imgCode     图形验证码,为:${imgToken}_${用户输入的验证码}
   * @param ifDecode    发送方式是否加密:0或null不加密,1加密
   * @param signNo      签署流水号
   * @param sign        请求参数签名
   * @param ts          请求签名时间戳
   * @returns {Promise<T>}
   */
  postApiUserSignSendCode ({ targetId, verifyType, imgCode, ifDecode, bsNo, mId, iden, sign, ts }) {
    let url = junziqianApi + ApiPort.signInfoController.sendCodeApi;
    let jsonData = {
      targetId: targetId,
      verifyType: verifyType,
      imgCode: imgCode,
      ifDecode: ifDecode || 0,
      bsNo: bsNo,
      mId: mId,
      iden: iden,
      sign: sign,
      ts: ts,
    };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署支付情况，签署支付，和身份认证支付 checkPay
   * @param signNo    签署编号
   * @returns {Promise<T>}
   */
  postSignCheckPay (signNo) {
    let url = junziqianApi + ApiPort.signInfoController.checkPay;
    let jsonData = { signNo: signNo };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 签署身份认证支付 authPay
   * @param signNo      签署编号
   * @param returnURL   支付完成跳转地址
   * @returns {Promise<T>}
   */
  postSignMultiAuthPay ({ signNo, returnURL, pay }) {
    let url = junziqianApi + ApiPort.signInfoController.signMultiPay;
    let jsonData = { signNo: signNo, returnURL: returnURL, pay };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
  /**
   * 签署身份认证支付 authPay
   * @param signNo      签署编号
   * @param returnURL   支付完成跳转地址
   * @returns {Promise<T>}
   */
  postSignAuthPay ({ signNo, returnURL, pay }) {
    let url = junziqianApi + ApiPort.signInfoController.authPay;
    let jsonData = { signNo: signNo, returnURL: returnURL, pay };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署支付 signPay
   * @param signNo      签署编号
   * @param returnURL   支付完成跳转地址
   * @returns {Promise<T>}
   */
  postSignContractToPay ({ signNo, returnURL, pay }) {
    let url = junziqianApi + ApiPort.signInfoController.signPay;
    let jsonData = { signNo: signNo, returnURL: returnURL, pay };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署合同 硬key doneNeedCa
   * @param chaptePages   chaptePages
   * @param sealPages     签署信息,例:[{page:1,chaptes:[{offsetX:0.1,offsetY:0.1,sealLevel:1,sealId:1},{}]},{…}…],sealLevel不能为空可以写0都行
   * @param signNo        签署流水号
   * @param sign          请求参数签名
   * @param ts            请求签名时间戳
   * @param pdfXml        签名后的pdf文件 needKey
   * @returns {Promise<T>}
   */
  postDoneNeedCa ({ chaptePages, sealPages, signNo, sign, ts, pdfXml }) {
    let url = junziqianApi + ApiPort.signInfoController.doneNeedCa;
    let position = _geolocation();
    let jsonData = {
      chaptePages: chaptePages,
      sealPages: sealPages,
      signNo: signNo,
      sign: sign,
      ts: ts,
      pdfXml: pdfXml,
      longitude: position.longitude,
      latitude: position.latitude,
    };

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  postUserSignAccountLogin ({ signNo, userId }) {
    let url = junziqianApi + ApiPort.signInfoController.userSignAccountLogin;
    let jsonData = { signNo: signNo, userId };
    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },

  postSendAuthSms ({ signNo, sign, ts, mobile }) {
    let url = junziqianApi + ApiPort.signInfoController.sendAuthSms;
    let jsonData = { signNo: signNo, sign: sign, ts: ts, mobile: mobile };
    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError);
  },
};



// WEBPACK FOOTER //
// ./assets/js/http-serve/signInfoController.js